import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@app/core/services";
import { LayoutService } from "@app/core/services/layout.service";

declare var $: any;

@Component({
  selector: "sa-header",
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit {
  public currentUser: any;
  public userUrl: string;
  public userId: string;
  public imageUrl: string = "";
  constructor(
    private router: Router,
    private authService: AuthService,
    private layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.currentUser = sessionStorage.getItem("userName");
    this.imageUrl = this.authService.imageUrl();

    this.userId = this.authService.getCurrentUserId();
    this.userUrl = "/user-profile/edit/" + this.userId;
  }

  get isAuthenticated() {
    return this.authService.loggedIn();
  }

  logOut() {
    this.authService.logOut();
  }

  searchMobileActive = false;

  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $("body").toggleClass("search-mobile", this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(["/miscellaneous/search"]);
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle();
  }
}
